// LDR Wishlist — shared state + heart-button behavior for every product card sitewide.
// Extracted from templates/collection.mens.liquid (source of truth) so it's no longer
// hand-copied per template. Backed by localStorage key 'ldr_wishlist'.
(function(){
  window.omnisend = window.omnisend || [];

  function syncWishlistCount(){
    const wlEl = document.getElementById('navWishlistCount');
    if (!wlEl) return;
    let list = [];
    try { list = JSON.parse(localStorage.getItem('ldr_wishlist') || '[]'); } catch(_) { list = []; }
    const n = Array.isArray(list) ? list.length : 0;
    wlEl.textContent = n;
    wlEl.classList.toggle('show', n > 0);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncWishlistCount);
  } else {
    syncWishlistCount();
  }
  window.addEventListener('storage', syncWishlistCount);

  window.LDRWishlist = {
    add: function(handle){
      let list = [];
      try { list = JSON.parse(localStorage.getItem('ldr_wishlist') || '[]'); } catch(_) {}
      if (!list.includes(handle)) list.push(handle);
      localStorage.setItem('ldr_wishlist', JSON.stringify(list));
      syncWishlistCount();
    },
    remove: function(handle){
      let list = [];
      try { list = JSON.parse(localStorage.getItem('ldr_wishlist') || '[]'); } catch(_) {}
      list = list.filter(h => h !== handle);
      localStorage.setItem('ldr_wishlist', JSON.stringify(list));
      syncWishlistCount();
    },
    get: function(){
      try { return JSON.parse(localStorage.getItem('ldr_wishlist') || '[]'); } catch(_) { return []; }
    }
  };

  // Swaps the "Wishlist"/"Saved" label text on hearts that have one (currently just .pdp-heart —
  // .pcard-heart is icon-only everywhere, so this is a no-op there since it has no text node).
  function setHeartLabel(btn, saved) {
    for (const node of btn.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        node.textContent = node.textContent.replace(/Wishlist|Saved/, saved ? 'Saved' : 'Wishlist');
        break;
      }
    }
  }

  function syncHearts() {
    if (!window.LDRWishlist) return;
    const list = window.LDRWishlist.get();
    document.querySelectorAll('.pcard-heart, .pdp-heart').forEach(btn => {
      const h = btn.dataset.handle;
      if (!h) return;
      const saved = list.includes(h);
      btn.classList.toggle('saved', saved);
      setHeartLabel(btn, saved);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncHearts);
  } else {
    syncHearts();
  }

  // Send Omnisend tracking — uses BOTH custom event (Pro plan) and tag + customProperties (all plans)
  function trackOmnisendAdd(handle) {
    fetch('/products/' + handle + '.js')
      .then(r => r.ok ? r.json() : null)
      .then(p => {
        if (!p) return;
        const v = (p.variants && p.variants[0]) ? p.variants[0] : null;
        const imgRaw = p.featured_image || (p.images && p.images[0]) || '';
        const imgUrl = imgRaw ? (imgRaw.indexOf('http') === 0 ? imgRaw : 'https:' + imgRaw) : '';
        const priceCents = p.price || 0;
        const priceDollars = '$' + (priceCents / 100).toFixed(2).replace(/\.00$/, '');
        const productURL = window.location.origin + (p.url || '/products/' + handle);

        // Resolve customer email — from logged-in customer or saved from Join the Club
        let emailRaw = window.LDR_CUSTOMER_EMAIL || '';
        if (!emailRaw) {
          try { emailRaw = localStorage.getItem('ldr_customer_email') || ''; } catch(_) {}
        }
        const emailValid = emailRaw && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailRaw);

        // 1) Custom event (works if on Pro plan + appears in "Custom Event" trigger dropdown)
        const eventData = {
          origin: 'wishlist_button',
          productID: String(p.id),
          variantID: v ? String(v.id) : '',
          productHandle: p.handle,
          productTitle: p.title,
          productVendor: p.vendor || 'LoadRunner Supply & Co.',
          productType: p.type || '',
          productPrice: priceCents,
          productCurrency: 'USD',
          productURL: productURL,
          productImageURL: imgUrl,
          productDescription: (p.description || '').replace(/<[^>]+>/g, '').slice(0, 240)
        };
        window.omnisend.push(['track', 'added to wishlist', eventData]);

        // 2) Tag + custom properties on the contact (works on ALL Omnisend plans)
        if (emailValid) {
          window.omnisend.push(['identifyContact', {
            email: emailRaw,
            tags: ['wishlist-added', 'wishlist-' + p.handle],
            customProperties: {
              wishlist_last_product_title: p.title,
              wishlist_last_product_url: productURL,
              wishlist_last_product_image: imgUrl,
              wishlist_last_product_price: priceDollars,
              wishlist_last_product_handle: p.handle,
              wishlist_last_added_at: new Date().toISOString(),
              wishlist_total_count: (window.LDRWishlist ? window.LDRWishlist.get().length : 1)
            }
          }]);
        }
      })
      .catch(() => {});
  }

  // Click delegate (capture phase) — works for any .pcard-heart / .pdp-heart, anywhere, automatically
  document.addEventListener('click', e => {
    const btn = e.target.closest('.pcard-heart, .pdp-heart');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    const h = btn.dataset.handle;
    if (!h || !window.LDRWishlist) return;
    const isSaved = btn.classList.contains('saved');
    if (isSaved) {
      window.LDRWishlist.remove(h);
      btn.classList.remove('saved');
      btn.setAttribute('aria-label', 'Save to wishlist');
      setHeartLabel(btn, false);
      if (window.showToast) window.showToast('Removed from wishlist');
    } else {
      window.LDRWishlist.add(h);
      btn.classList.add('saved');
      btn.setAttribute('aria-label', 'Remove from wishlist');
      setHeartLabel(btn, true);
      if (window.showToast) window.showToast('Saved to wishlist');
      // Push Omnisend event ONLY on add
      trackOmnisendAdd(h);
    }
    btn.classList.remove('pulse'); void btn.offsetWidth; btn.classList.add('pulse');
  }, true);

  // Capture email entered in the Join the Club form so wishlist events can identify the contact
  document.addEventListener('submit', e => {
    const form = e.target;
    if (form && form.id === 'clubForm') {
      const emailInput = form.querySelector('input[type=email]');
      if (emailInput && emailInput.value) {
        try { localStorage.setItem('ldr_customer_email', emailInput.value.trim()); } catch(_) {}
      }
    }
  });

  // Cross-tab sync
  window.addEventListener('storage', e => {
    if (e.key === 'ldr_wishlist') syncHearts();
  });
})();
